import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { formattedCurrency } from "utils";
import { useDictionary } from "hooks";
import { isNumber } from "@cayuse/shared-react.utils.type-checks";
import Table from "components/Table";

import styles from "./styles.css";

const DistributionTable = ({
	totalExpected,
	obligated,
	distributed
}) => {
	const dictionary = useDictionary("awards.distributionTable");
	
	const calculateRemainingDistributed = () => {
		return obligated - distributed;
	};

	const remainingDistributed =
		isNumber(obligated) && isNumber(distributed) && !isNaN(obligated) && !isNaN(distributed)
			? calculateRemainingDistributed()
			: 0;

	const renderTableBody = () => {
		const formattedExpected = formattedCurrency(totalExpected);
		const formattedObligated = formattedCurrency(obligated);
		const formattedDistributed = formattedCurrency(distributed);
		const formattedRemainingDistributed = formattedCurrency(remainingDistributed);

		return (
			<Table.Body>
				<Table.Row>
					<Table.Cell>
						{formattedExpected}
					</Table.Cell>
					<Table.Cell>
						{formattedObligated}
					</Table.Cell>
					<Table.Cell >
						{formattedDistributed}
					</Table.Cell>
					<Table.Cell>
						{formattedRemainingDistributed}
					</Table.Cell>
				</Table.Row>
			</Table.Body>
		);
	};

	return (
		<div>
			<Table data-component="DistributionTable" className={styles.distributionTable} captionText="Distribution">
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell className={styles.headerCellStyle}>
							{dictionary.totalAmount ?? "Total Expected Amount"}
						</Table.HeaderCell>
						<Table.HeaderCell className={styles.headerCellStyle}>
							{dictionary.obligatedAmount ?? "Obligated Amount"}
						</Table.HeaderCell>
						<Table.HeaderCell className={styles.headerCellStyle}>
							{dictionary.distributed ?? "Distributed"}
						</Table.HeaderCell>
						<Table.HeaderCell className={styles.headerCellStyle}>
							{dictionary.remainingDistributed ?? "Remaining to be Distributed"}
						</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				{renderTableBody()}
			</Table>
		</div>
	);
};
DistributionTable.propTypes = {
	totalExpected: PropTypes.number,
	obligated: PropTypes.number,
	distributed: PropTypes.number
};

export default DistributionTable;